const blockMd = {
	group: "block",
	attrs: { text: { default: null }, tag: { default: null } },
};

export default blockMd;
